import { getAxiosClient } from './index';

export const authenticate = (email: string, password: string) => {
    const restClient = getAxiosClient();
    return restClient.post('/admin/login', { email, password });
};
